import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import device from "../../assets/device.png";
import "./styles.css";
import InputField from "../../components/inputField";
import ReCAPTCHA from "react-google-recaptcha";
import routeNames from "../../routes/routeNames";
import { backendUrl } from "../../constants";
import { Navigate, useNavigate } from "react-router-dom";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import GoogleSignIn from "../../components/googleSignInComponent";

const Index = () => {
  const navigate = useNavigate();
  const [agree, setAgree] = useState();
  const [role, setRole] = useState("");

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      zip: "",
      pass: "",
      rePass: "",
    },

    // functions will be used to validate values at corresponding key
    validate: {
      firstName: (value) =>
        value?.length < 1 ? "Please enter first name" : null,
      lastName: (value) =>
        value?.length < 1 ? "Please enter last name" : null,
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      company: (value) =>
        value?.length < 1 ? "Please enter company name" : null,
      zip: (value) => (value?.length < 1 ? "Please enter Zip code" : null),
      pass: (value) =>
        value?.length < 8 ? "Password must at least have 8 characters" : null,
      rePass: (value, values) =>
        value !== values?.pass ? "Passwords did not match" : null,
    },
  });

  //for role_id
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}roles/listRoles`, options)
      .then((response) => response.json())
      .then((response) => {
        let role = response.data.find((obj) => obj.name == "Company")._id;
        setRole(role);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleSignUp = (values) => {
    let obj = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      password: values.pass,
      zipCode: values.zip,
      companyName: values.company,
      role: role,
    };
    if (agree) {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(obj),
      };
      fetch(`${backendUrl}user/addUser`, options)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            showNotification({
              title: "Success",
              message:
                "Account Has Been Created. Please Wait For The Admin To Approve Your Account",
              color: "orange",
            });
            navigate(routeNames.EMPLOYER_SIGNIN);
          } else {
            showNotification({
              title: "Error",
              message: response.message,
              color: "red",
            });
          }
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <Page className="landing-page">
      <div className="main1">
        <form
          onSubmit={form.onSubmit((values) => handleSignUp(values))}
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="mainContent">
            <div className="formm">
              <h4 className="pb-1 text-center text-dark">
                Create Your Company Profile
              </h4>

              <div className="col-md-12 d-flex gap-2 flex-column">
                <InputField
                  placeholder={"First Name"}
                  width="100%"
                  validateName="firstName"
                  form={form}
                />

                <InputField
                  placeholder={"Last Name"}
                  className="m"
                  width="100%"
                  validateName="lastName"
                  form={form}
                />
                <InputField
                  placeholder={"Company Name"}
                  className="m"
                  width="100%"
                  validateName="company"
                  form={form}
                />
                <InputField
                  placeholder={"Zip Code"}
                  className="m"
                  width="100%"
                  validateName="zip"
                  form={form}
                />
                <InputField
                  placeholder={"Enter Email"}
                  className="m"
                  type="email"
                  width="100%"
                  validateName="email"
                  form={form}
                />
                <InputField
                  placeholder={"Enter Password"}
                  className="m"
                  type="password"
                  width="100%"
                  validateName="pass"
                  form={form}
                />
                <InputField
                  placeholder={"Re-Enter Password"}
                  className="m"
                  type="password"
                  width="100%"
                  validateName="rePass"
                  form={form}
                />
              </div>
            </div>
            <div className="d-flex flex-column w-100">
              <div
                className="captcha"
                style={{
                  transform: "scale(0.75)",
                  transformOrigin: "10px 25px",
                }}
              >
                <ReCAPTCHA sitekey="Your client site key" />
              </div>
              <div className="form-check">
                <input
                  className="form-check-input bg-danger border-white"
                  type="checkbox"
                  value={agree}
                  id="flexCheckChecked"
                  onChange={(v) => setAgree(v.target.checked)}
                />
                <label
                  className="form-check-label text-black"
                  htmlFor="flexCheckChecked"
                >
                  I agree to the{" "}
                  <a href={routeNames.general.terms} className=" text-dark">
                    terms and conditions
                  </a>
                  .
                </label>
              </div>
            </div>
            <div className="w-100 align-items-center d-flex flex-column gap-2">
              <Button
                title={"Create FREE Employer Account"}
                primary={true}
                disable={false}
                fontWeight="700"
                type="submit"
                width="100%"
                // onClick={handleSignUp}
              />
              {role && <GoogleSignIn type={role} />}
              {/* <Button
                title={"Sign in with Facebook"}
                icon={"fb"}
                fontWeight="700"
                type="submit"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  backgroundColor: "rgb(12, 80, 170)",
                  color: "white",
                }}
              /> */}
            </div>
          </div>
        </form>
      </div>
      <div className="employer1">
        <h2 className="mt-1 mb-4 text-center head">Build Your Own Profile</h2>
        <div className="jobSeeker">
          <div className="jobContent">
            <ul style={{ fontSize: "20px" }}>
              <li>Search Unlimited Job Seekers & Resumes!</li>
              <li>Unlimited 100% FREE Job Postings!</li>
              <li>Interactive back-end analytics!</li>
              <li>
                Utilize your company's brand & allow Job Seekers to explore your
                company!
              </li>
            </ul>
          </div>
          <img src={device} className="sideImage" />
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
